import { render, staticRenderFns } from "./RecordedLargeCard.vue?vue&type=template&id=3b4f224c&scoped=true&"
import script from "./RecordedLargeCard.vue?vue&type=script&lang=ts&"
export * from "./RecordedLargeCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecordedLargeCard.vue?vue&type=style&index=0&id=3b4f224c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f224c",
  null
  
)

export default component.exports